import { default as teacherPositionCategory } from './position-category/services' 

export default { 
	teacherPositionCategory 
}
